import { render } from "./DummyPage.vue?vue&type=template&id=4b39794c"
import script from "./DummyPage.vue?vue&type=script&lang=js"
export * from "./DummyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__